import type * as zod from 'zod';

import { ProcessorPresetId } from '@sb/service-interfaces/host/processorPresets';
import { HostCapabilities } from '@sb/service-interfaces/host/types';

/** Host-scoped, not robot-scoped: several simulated robots share one box. */
export const HostCapabilitiesData = HostCapabilities.extend({
  /** Null when the host reports real hardware. */
  simulatedPresetId: ProcessorPresetId.nullable(),
});

export type HostCapabilitiesData = zod.infer<typeof HostCapabilitiesData>;

/**
 * The service's single record. Patch this rather than `null`: `patch(null, …)`
 * is "patch many", whose event carries no id, so no subscriber re-runs.
 */
export const HOST_CAPABILITIES_ID = '1';
